import { isDevMode, LOCALE_ID, NgModule, provideAppInitializer } from '@angular/core';
import {DEFAULT_LOCALE, SUPPORTED_LOCALES} from '@dv/shared/code';
import {Translator} from '@dv/shared/translator';
import {provideTransloco, TRANSLOCO_TRANSPILER} from '@jsverse/transloco';
import {provideTranslocoMessageformat} from '@jsverse/transloco-messageformat';
import 'moment/locale/de';
import 'moment/locale/fr';
import {initAngularLocales, initMoment, initTransloco} from './app-initializers';
import {KitAdminTranslationLoader} from './KitAdminTranslationLoader';
import {KitAdminTranspiler} from './KitAdminTranspiler';
import {TranslatorTranslocoAdapterService} from './translator-transloco-adapter.service';

@NgModule({
    providers: [
        provideTransloco({
            config: {
                availableLangs: SUPPORTED_LOCALES.values,
                defaultLang: DEFAULT_LOCALE,
                reRenderOnLangChange: true,
                fallbackLang: DEFAULT_LOCALE,
                missingHandler: {
                    useFallbackTranslation: true,
                },
                prodMode: !isDevMode(),
            },
            loader: KitAdminTranslationLoader,
        }),
        provideTranslocoMessageformat({
            currency: 'CHF',
            locales: SUPPORTED_LOCALES.values,
        }),
        {provide: TRANSLOCO_TRANSPILER, useClass: KitAdminTranspiler},
        {provide: LOCALE_ID, useValue: DEFAULT_LOCALE},
        {provide: Translator, useClass: TranslatorTranslocoAdapterService},
        provideAppInitializer(() => initTransloco()),
        provideAppInitializer(() => initMoment()),
        provideAppInitializer(() => initAngularLocales()),
    ],
})
export class I18nModule {
}
